// extracted by mini-css-extract-plugin
module.exports =  {"SPTooltip":"SPTooltip__JkAy9"};